// Browser GPS with friendly errors; resolves {lat, lng, accuracy} or rejects with a user-facing message.
export function getCurrentPosition(timeout = 10000) {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) { reject(new Error("Is device par location support nahi hai.")); return; }
    navigator.geolocation.getCurrentPosition(
      (p) => resolve({ lat: p.coords.latitude, lng: p.coords.longitude, accuracy: p.coords.accuracy }),
      (e) => reject(new Error(e.code === 1 ? "Location permission nahi mili. Browser settings me allow karein." : e.code === 3 ? "Location milne me der ho gayi. Dobara try karein." : "Abhi location nahi mil paayi (GPS unavailable).")),
      { enableHighAccuracy: true, timeout, maximumAge: 60000 },
    );
  });
}

export const isLatLng = (lat, lng) => Number.isFinite(Number(lat)) && Number.isFinite(Number(lng)) && Math.abs(lat) <= 90 && Math.abs(lng) <= 180 && !(Number(lat) === 0 && Number(lng) === 0) && lat !== "" && lat !== null && lng !== null;

// Opens Google Maps directions in a new tab synchronously (no VerB location request; Google resolves "current location" itself).
export function openDirections(url) {
  if (!url) return;
  const a = document.createElement("a");
  a.href = url; a.target = "_blank"; a.rel = "noopener noreferrer";
  document.body.appendChild(a); a.click(); a.remove();
}
